
import React, { Component } from "react"
import FullCalendar from '@fullcalendar/react'
import frLocale from '@fullcalendar/core/locales/fr'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin, { Draggable } from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from 'react-meta-tags'
import "./cal.css"
import DetailModal from "./DetailModal"
import url from "../../common/api"
import { format } from 'date-fns';
import  { Redirect } from 'react-router-dom'
import {getEvenementByProfile,getEvenementByUser} from "../../services/evenementService.js"

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardHeader,
    CardTitle,
    FormGroup,
    Label,
    Button,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Breadcrumb,
    BreadcrumbItem,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Dropdown,
    Spinner,
  
  } from "reactstrap"

const events = [{
    id: 1,
    color: '#fd3153',
    from: '2021-05-02T18:00:00+00:00',
    to: '2021-05-05T19:00:00+00:00',
    title: 'ceci est un evenement'
}, {
    id: 2,
    color: '#1ccb9e',
    from: '2019-05-01T13:00:00+00:00',
    to: '2019-05-05T14:00:00+00:00',
    title: 'This is another event'
}, {
    id: 3,
    color: '#3694DF',
    from: '2019-05-05T13:00:00+00:00',
    to: '2019-05-05T20:00:00+00:00',
    title: 'This is also another event'
}];

class liste extends React.Component {
    constructor(props) {
        super(props)
        this.handleDateClick = this.handleDateClick.bind(this)
        this.handleEventClick = this.handleEventClick.bind(this)
        this.calendarComponentRef = React.createRef()
    
        this.state = {
          calendarWeekends: true,
          modal: false,
          modalcategory: false,
          isDragBind: false,
          detailModal: false,
          events: [],
          default_event:[],
          event :{},
          droit:JSON.parse(sessionStorage.getItem("profileAuthAshia"))?.droit_evenement?.creer?true:false,
          ok:"",
          chargement:false,
          chargement2:true,
          dropdownOpen: false,
          title:"Tous les évènements"
        }
    
        this.toggle = this.toggle.bind(this)
        this.toggle2 = this.toggle2.bind(this);
        this.handleShowEvent=this.handleShowEvent.bind(this)
       
      }
      componentDidMount() {
        $(".fc-next-button").css("background-color","#5ac2e5")
        this.handleChargerData()
        sessionStorage.setItem("sis-session",900000)
      }

      toggle() {
        this.setState(prevState => ({
          modal: !prevState.modal,
        }))
      }
      handleDateClick = arg => {
        this.setState({ selectedDay: arg })
        this.toggle()
      }  
      handleEventClick = arg => {
        const event = arg.event
        this.setState({detailModal:true})
        console.log("evenement:",event) 

        this.setState({
            event:event._def.extendedProps
        })

        this.toggle()
      }
      handleChargerData=()=>{
        // var data=JSON.parse(sessionStorage.getItem("authAshia"))?.profile
        const profile_id=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id?JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id:JSON.parse(sessionStorage.getItem("authPublic"))?.id

        this.setState({events:[]})
        //this.setState({events:[{title:"titre1" ,start:"2021-06-02",end:"2021-06-05"}]})
      getEvenementByProfile({profile_id}).then(data=>{
  
            console.log("les evenements,",data)
            if(!data.length){
              this.setState({chargement:true,title:"Tous les évènements"})
              $(".fc-next-button").css("background-color","#5ac2e5")
            }
            data.map((element,idx) =>{
              var date=new Date(element.date_fin)

              date.setDate(date.getDate() + 1)
            
              var tab= {
                title: element.libelle,
                //thematique: element.nom,
                id_event: element.id,
                //format: element.format.code,
                //langue: element.nom,
                color: "info",
                libelle :element.libelle,
                lieu: element.lieu,
                heure_debut: element.heure_debut,
                heure_fin: element.heure_fin,
                description: element.description,
                organisateur:element.organisateur,
                cible:element.cible,
                date_debut:format(new Date(element.date_debut),'dd/MM/yyyy'),
                date_fin:format(new Date(element.date_fin),'dd/MM/yyyy'),
                start:format(new Date(element.date_debut),'yyyy-MM-dd'),
                end: format(new Date(date),'yyyy-MM-dd'),

                //typesystemeirrigue: element.nom,
             
        
                
              }
             
              this.setState({events:[...this.state.events,tab],default_event:[...this.state.default_event,tab]})
              if(idx==data.length-1){
                this.setState({chargement:true})
              }
            })
          
            
            
           }
           

         );
      }

      handleShowEvent=(data)=>{
        this.setState({events:[]})
        data.map((element,idx) =>{
            
          var tab= {
            title: element.libelle,
            //thematique: element.nom,
            id_event: element.id,
            //format: element.format.code,
            //langue: element.nom,
            color: "info",
            libelle :element.libelle,
            lieu: element.lieu,
            heure_debut: element.heure_debut,
            heure_fin: element.heure_fin,
            description: element.description,
            organisateur:element.organisateur,
            cible:element.cible,
            date_debut:format(new Date(element.date_debut),'dd/MM/yyyy'),
            date_fin:format(new Date(element.date_fin),'dd/MM/yyyy'),
            start:format(new Date(element.date_debut),'yyyy-MM-dd'),
            end: format(new Date(element.date_fin),'yyyy-MM-dd'),

            //typesystemeirrigue: element.nom,
         
    
            
          }
          this.setState({events:[...this.state.events,tab]})
        
        })

      }

      handleAjouter=()=>{
        this.setState({ok: <Redirect to='/ajout-evenement'  />});
      }

      handleListeEvenement=()=>{
        this.setState({ok: <Redirect to='/liste-evenement'  />});
      }

      getMyEvent=()=>{
        this.setState({chargement2:false,title:""})
        const user_id=JSON.parse(sessionStorage.getItem("authAshia"))?.id

         getEvenementByUser({user_id}).then(data=>{
           this.setState({chargement2:true,ressourceData:data,title:"Mes évènements"})
           this.handleShowEvent(data)
         })
     }     
 
 
       toggle2() {
         this.setState(prevState => ({
           dropdownOpen: !prevState.dropdownOpen
         }));
       }



      
    render() {
        const { isEdit, detailModal } = this.state
        $(".fc-next-button").css("background-color","#5ac2e5")
        return (

            <React.Fragment> 
              {
            (this.state.chargement)?
                (<>
                 {this.state.ok}

             <DetailModal
                show={detailModal}
                event={this.state.event}
                onCloseClick={() => this.setState({ detailModal: false })}
             />
                 <MetaTags>
                    <title>Calendrier | SIS</title>
                </MetaTags>
                <Container fluid={true} id="cal">
                <Breadcrumbs title="SIS" breadcrumbItem="Calendrier" />


                <Row className=" mt-3 mb-3">
                  <Col  lg="7"></Col>
                  {
                  this.state.droit?
                  <Col lg="2" md="2" sm="12" className="pull-right">
                      <Dropdown style={{borderRadius:"10px"}}  isOpen={this.state.dropdownOpen} toggle={this.toggle2}>
                        <DropdownToggle style={{borderRadius:"10px"}}  color="info" caret>
                          {this.state.title}
                          {
                            !this.state.chargement2?<>Chargement... <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/></>:null
                          }
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={e=>{this.setState({events:this.state.default_event,title:"Tous les évènements"})}}>Tous les évènements</DropdownItem>
                          <DropdownItem divider />
                          <DropdownItem onClick={this.getMyEvent}>Mes évènements</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                  </Col>:null
                  }

                  {this.state.droit?
                    <Col  lg="3" className="pull-right">
                      <Button
                      
                        className="font-16 btn-block btn   float-right"
                        style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}
                        onClick={this.handleAjouter}
                      >
                        <i className="mdi mdi-plus-circle-outline me-1" />
                        Ajouter un événement
                      </Button>
                    </Col>:null
                   }
                 
                </Row>
                
                <hr/>

                <Card style={{borderRadius:"25px"}}>
                  <CardBody>
                    <Row >
                      <Col className="col-lg-12">

                        <FullCalendar
                          locale={frLocale}
                          defaultView="dayGridMonth"
                          header={{
                            left: "prev,next today",
                            center: "title",
                            right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
                          }}
                          plugins={[
                            BootstrapTheme,
                            dayGridPlugin,
                            interactionPlugin,
                          ]}
                          slotDuration={"00:15:00"}
                          handleWindowResize={true}
                          themeSystem="bootstrap"
                          // events={events}
                          editable={false}
                          droppable={false}
                          selectable={true}
                          dateClick={this.handleDateClick}
                          eventClick={this.handleEventClick}
                          // drop={this.onDrop}
                          events={this.state.events}
                        />

                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                
              </Container>
              </>):(
              <div style={{marginTop:"250px",textAlign:"center"}}>
                <Spinner type="grow" color="secondary" />
              </div>
            )
            
          }
            </React.Fragment>
           
        );
    }
}

export default liste